import type { ReactNode } from "react";
import { Alert, Button, type PortalSignableDocument } from "@dearbill/shared";

interface SignBlockedProps {
  doc: PortalSignableDocument;
  /** Only `doc.signerName`, not this session, may sign the document. */
  memberOnly: boolean;
  onDone: () => void;
}

/** An unsigned document this session can't sign, with the reason and the way back. */
export function SignBlocked({ doc, memberOnly, onDone }: SignBlockedProps): ReactNode {
  const name = doc.signerName || "the member";
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-h3 text-midnight font-serif">{doc.title}</h1>
      {memberOnly ? (
        <Alert tone="info" title="Only the member can sign this authorization.">
          {`This authorization is ${name}'s own, so ${name} needs to sign it. Ask them to sign in to their DearBill account with their own details and sign it there.`}
        </Alert>
      ) : (
        <Alert tone="info" title="This document isn't ready to sign yet.">
          {"We'll let you know when it's ready. You can check its status on your dashboard."}
        </Alert>
      )}
      <div>
        <Button variant="secondary" size="md" onClick={onDone}>
          Back to your dashboard
        </Button>
      </div>
    </div>
  );
}
